export default __webpack_public_path__ + "static/Heartfulness_Logo_Centered_Unity_Type-1-db4d07c4927395a4e78b430427026f0f.png";